import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sc-auth-home" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold" }, "功能列表", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.userStatus.identity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, " 您好，" + _toDisplayString(_ctx.userStatus.identity), 1),
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportExcel && _ctx.exportExcel(...args)))
              }, "导出数据")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}